// {
//   index: 0,
//   name: "案件1",
//   theme: ["生育托兒", "社會關懷"],
//   themetab: ["", "原住民"],
//   organ: ["民政局"],
//   organtab: [""],
//   apply: "線上 / 臨櫃",
//   day: 7,
//   info: [
//     "【申請資格】<br /><br />1.照顧五足歲以下兒童。<br />2.兒童及申請人設籍並實際居住臺北市（以下簡稱本市）一年以上。<br />3.申請人經稅捐稽徵機關核定之最近一年綜合所得總額合計未達申報標準或綜合所得稅稅率未達百分之二十。<br />4.兒童未經政府公費安置收容。<br />5.兒童未領有政府低收入戶生活補助、危機家庭兒童及少年生活補助或其他生活類之補助或津貼。<br /><br />【其他申請資格】<br /><br />前項第二款之設籍本市一年以上",
//     "指申請日向前推算連續設籍本市一年以上。<br /> 符合下列情形之一者",
//     "兒童得不受第一項第二款設籍並實際居住本市一年以上之限制：<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp(1)兒童未滿一歲",
//     "其出生登記或初設戶籍登記於本市",
//     "且戶籍未有遷出本市紀錄。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp(2)兒童經完成收養登記未滿一年",
//     "且戶籍遷入本市未有遷出紀錄。<br />兒童父母之一方為無戶籍國民、大陸地區人民或外國籍人士",
//     "得不受第一項第二款設籍本市之限制。",
//   ],
//   file:
//     "請備齊以下文件：<br />(一)申請人親自申請：申請表、申請人之身分證、印章及金融機構存摺封面影本。<br />(二)委託他人代為申請：申請表、受託人之身分證及印章、申請人之身分證、親筆簽名或蓋章之委託書及金融機構存摺封面影本。<br />申請表置於檔案下載區。",
//   臨櫃辦理: "請備齊應備文件向臺北市各區戶政事務所或各區公所社會課現場辦理。",
//   noonline: "請備齊應備文件向臺北市各區戶政事務所或各區公所社會課現場辦理。",
//   download: [
//     "臺北市育兒津貼申請表（109年版本）.doc",
//     "臺北市育兒津貼申請表（109年版本）.odt",
//     "臺北市育兒津貼申請表（109年版本）.pdf",
//   ],
// },

const caseData = [
  {
    index: 0,
    name: "中低收入戶原住民建購或修繕住宅補助",
    theme: ["社會關懷", "補助獎勵", "住屋相關"],
    themetab: ["中低收入戶", "其他", "居住"],
    organ: ["原民會"],
    organtab: ["原民會"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "6日",
    info: [
      "【建購補助】<br />1.申請書。<br />2.全戶最新各類所得歸戶清單。<br />3.全戶之全國檔歸戶財產清單。<br />4.建物登記謄本或房屋所有權狀影本。<br />5.未獲其他政府建購住宅補助切結書。<br />6.住宅照片。<br />7.房屋稅單、房屋稅籍或水電繳費收據等任一種影本。<br />8.存摺帳戶影本。<br />9.領款收據。<br /><br />【修繕補助】<br />同前項(1)至(4)項及(7)至(9)項",
      "加附：<br />1.修繕工程估價單（所需之工程、材料、工資等估價單）。<br />2.最近五年未曾獲政府其他修繕住宅補助切結書。<br />3.預備修繕住宅位置照片（每處一張）。",
    ],
    file: [
      "1.戶籍資料及土地、建物登記資料由本會透過市政資料庫查詢。<br />2.非設籍臺北市之人民",
      "因市政資料庫無法查詢戶籍資料",
      "申請時需檢附一個月內之全戶戶籍謄本1份",
      "但原民會已有相關資料足以證明者除外。<br />3.申請人若與配偶分戶者",
      "應同時檢附配偶之戶籍謄本。<br />4.應備證件需附正本部分",
      "可以影本先行申請",
      "俟審核通過後再補寄正本",
      "始得撥款。",
    ],
    noonline: "請備齊應備文件向原民會社會福利組現場辦理。",
    download: [
      "建購修繕申請文件.doc",
      "建購修繕申請文件.pdf",
      "中低收入戶原住民建購或修繕住宅補助申請書-範例.doc",
      "103年度中低收入戶原住民建購",
      "修繕住宅補助業務實施計畫.pdf",
      "一次告知單-公寓出租、住宅補助、法律訴訟費補助、補助文化活動等.doc",
    ],
  },
  {
    index: 1,
    name: "中低收入戶查定",
    theme: ["社會關懷","戶政相關"],
    themetab: ["中低收入戶","戶籍"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "全線上／臨櫃",
    day: "40日 - 60日",
    info: [
      "【申請管道與注意事項】<br />1.本市市民逕向區公所申請。<br />2.福利申請以申請人檢附完整資料之日為受理申請日",
      "經審核通過後溯至受理申請月份生效。<br /><br />【備註】<br />1.均需訪視。<br />2.初審合格者",
      "由區公所核復。<br />3.區公所初審不合格之案件函送社會局辦理複審核定。<br />4.申請時請自行檢視",
      "相關文件經同意受理將不予退件。<br />5.外國文件需先翻譯成中文並經駐外單位驗證簽章。",
    ],
    file: [
      "1. 申請表1份。<br />2. 新式戶口名簿(含詳細記事)影本。<br />3. 戶內人口如為在臺無戶籍國民（含華僑）、外籍人士或大陸地區人民",
      "應檢附相關人口身分證明文書（如有效之居留證、親屬關係公證書、常住人口登記表等）。<br />4. 納稅義務人事後辦理剔除扶養人口並補繳最近一年度綜合所得稅者",
      "應檢附國稅局更正後核定通知書。<br />5. 租賃契約影本或借住證明正本(借住須附房屋稅證明或所有權狀影本)。<br />6. 申請人之市庫指定行庫（現為台北富邦商業銀行）或郵局存摺封面影本。<br />7. 家戶內人口如有下列證明文件者",
      "請一併提供：(1)人口資料 (2)收入、財產異動資料 (3)身心障礙及醫療資料 (4)託他人代申請、代填申請表及代為簽名/蓋章/線上簽核者",
      "應檢附代申請人身分證明文件影本。",
    ],
    noonline: "請備齊應備文件向臺北市各區戶政事務所或各區公所社會課現場辦理。",
    download: [
      "臺北市社會扶助申請表.doc",
      "臺北市社會扶助申請表.odt",
      "臺北市社會扶助申請表.pdf",
    ],
  },
  {
    index: 2,
    name: "中低收入老人假牙補助",
    theme: ["社會關懷", "補助獎勵"],
    themetab: ["中低收入戶", "醫療"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "8日",
    info: [
      "1.年滿55歲以上列冊本市之低收入戶者、中低收入戶者。<br />2.年滿65歲以上經本市公費收容安置者、領有本市中低收入老人生活津貼者、中低收入領有本市收容安置補助者、領有本市身心障礙者生活補助費者、經本市補助身心障礙者日間照顧及住宿式照顧費用達50%以上者。<br />符合以上其一資格之民眾",
      "持身分證明文件至臺北市立聯合醫院或經臺北市牙醫師公會所屬醫療院所檢查需裝置之假牙項目",
      "由醫療院所依規定流程向社會局提出補助申請。",
    ],
    file: [
      "1.年滿55 歲以上列冊本市之低收入戶者請持身分證及本市低收入戶卡。<br />2.年滿65 歲以上經本市公費收容安置者請持身分證及本市公費收容安置機構開立入住證明。<br />3.年滿55歲以上列冊本市中低收入戶者請持身分證及本市中低收入戶卡。<br />4.年滿65歲以上領有本市中低收入老人生活津貼者請持身分證及由區公所開立中低收入老人生活津貼證明或核准函(或中低收入老人生活津貼總清查通知)。<br />5.年滿65歲以上中低收入領有本市收容安置補助者請持身分證及由社會局老人福利科開立中低收入領有本市收容安置補助證明。<br /><br />6.年滿65歲以上領有本市身心障礙者生活補助費者請持身分證及區公所開立身心障礙者生活補助費證明(或身心障礙者生活補助費總清查通知)。<br />7.年滿65歲以上經本市補助身心障礙者日間照顧及住宿式照顧費用達50%以上者請持身分證及社會局身心障礙科開立之本市補助身心障礙者日間照顧及住宿式照顧費用達50％以上之有效核准公文或證明。<br />8.民眾持身分證明文件至臺北市立聯合醫院或經臺北市牙醫師公會所屬醫療院所檢查需裝置之假牙項目",
      "由醫療院所依規定流程向社會局提出補助申請。<br />9.診治計畫書及醫院診斷證明書（需註明假牙裝置項目、部分活動及固定假牙需註明部位【以健保申報牙位為準】、所需費用）及公會審核所需文件。<br />10.申請人同意補助款撥付醫療院所切結書。<br />11.個人資料蒐集處理利用同意書。",
    ],
    noonline: [
      "民眾持身分證明文件至臺北市立聯合醫院或經臺北市牙醫師公會所屬醫療院所檢查需裝置之假牙項目",
      "由醫療院所依規定流程向社會局提出補助申請。",
    ],
    download: "中低收入老人假牙補助",
  },
  {
    index: 3,
    name: "中低收入老人特別照顧津貼",
    theme: ["社會關懷", "補助獎勵"],
    themetab: ["中低收入戶", "其他"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "全線上／臨櫃",
    day: "6日",
    info: [
      "本案可逕向各區老人服務中心申請",
      "如使用線上申請",
      "亦需由本局派案老人服務中心到宅進行失能評估及照顧事實。",
    ],
    file:
      "1.申請表<br />2.照顧者及受照顧者身分證正、背面影本<br />3.照顧者於社會局指定之金融機構存摺封面影本",
    noonline: ["逕向老人服務中心申請", "並由老人中心送回或寄回業務科辦理。"],
    download: [
      "中低收入老人特別照顧津貼作業流程",
      "中低收入老人特別照顧津貼申請表.doc",
      "中低收入老人特別照顧津貼申請表.odt",
      "中低收入老人特別照顧津貼申請表.pdf",
    ],
  },
  {
    index: 4,
    name: "低收入戶及中低收入戶生育補助",
    theme: ["生育托兒", "社會關懷", "補助獎勵"],
    themetab: ["", "中低收入戶", "其他"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "全線上／臨櫃",
    day: "6日",
    info: [
      "申請人應自分娩、流產或死產之次日起六十日內向本局提出申請",
      "逾期概不受理(申請本補助以掛號郵寄方式向本局提出者",
      "以郵戳為憑",
      "其餘以本局收文日為準)",
    ],
    file:
      "【第一類】：分娩且完成子女之出生登記。<br />(1)申請表1份。<br />(2)具領人之郵局或銀行存摺封面影本1份（需清楚列明該存摺局號及帳號）。<br /><br />【第二類】：懷孕12週以上流產或死產。<br />(1)申請表1份。<br />(2)醫師診斷證明書1份（需明列懷孕週數及流產或死產原因）。<br />(3)具領人之郵局或銀行存摺封面影本1份（需清楚列明該存摺局號及帳號）。",
    noonline: "請備齊應備文件向臺北市政府社會局社會救助科現場辦理。",
    download: [
      "臺北市政府社會局「低收入戶及中低收入戶生育及懷孕補助」作業流程圖",
      "臺北市低收入戶及中低收入戶生育補助申請表.doc",
      "臺北市低收入戶及中低收入戶生育補助申請表.odt",
      "臺北市低收入戶及中低收入戶生育補助申請表.pdf",
    ],
  },
  {
    index: 5,
    name: "臺北市公立國小原住民學生學校午餐補助",
    theme: ["社會關懷", "補助獎勵"],
    themetab: ["原住民", "其他"],
    organ: ["原民會"],
    organtab: ["原民會"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "55日",
    info: [
      "1.得向該就讀學校申請。<br />2.設籍時間依本會公告。<br />3.以上申請者不包含研究所及空中大學（專科）、推廣部、學分班、在職專班學、低收入戶、中低收入戶。<br /><br />【簡易流程說明】<br />(1)第一階段:每年3月初及9月初受理申請",
      "申請截止後",
      "由學校或區公所彙整造冊並完成線上申請。<br />(2)第二階段:臺北市政府原民會複審後",
      "函知核定結果。<br />(3)第三階段:各區公所接獲核定通知後",
      "轉知申請人。",
    ],
    file:
      "1.彙整之清冊及申請書<br />2.學生家戶所得清單(需含父母)<br />3.戶口名簿影本",
    noonline: "請備齊應備文件向原民會教育文化組現場辦理。",
    download: [
      "臺北市公立國民小學原住民學生午餐補助作業流程圖",
      "午餐補助申請書、請領清冊及領據黏貼用單.doc",
      "午餐補助申請書、請領清冊及領據黏貼用單.pdf",
      "臺北市原住民學生教育補助要點.pdf",
      "一次告知單-教育文化.doc",
    ],
  },
  {
    index: 6,
    name: "教育部補助地方政府發放二至四歲幼兒育兒津貼",
    theme: ["社會關懷", "生育托兒"],
    themetab: ["婦幼", ""],
    organ: ["教育局"],
    organtab: ["教育局"],
    apply: "全線上",
    day: "20日-28日",
    info: [
      "本案僅限網路預約",
      "申請人仍需持應備文件親臨或郵寄至戶籍地區公所方能正式受理。",
    ],
    file: [
      "1.申請表正本（需父母雙方、或監護人、或實際照顧者須於申請表上簽名或蓋章）。<br />2.申請人(父母雙方、或監護人、或實際照顧者) 的身分證明文件及幼兒身分證明文件(如：戶口名簿影本)。<br />3.申請人(父母其中一方、或監護人)或幼兒本人之郵局或市庫代理金融機構(台北富邦銀行) 帳戶影本。<br />4.申請人其中一方為在臺無戶籍、大陸地區人民或外籍人士者",
      "請檢附居留證影本或護照影本。<br />5.第3名以上子女相關證明文件或其他相關佐證資料等。",
    ],
    noonline: ["無", "本案僅限網路預約。"],
    download: [
      "臺北市育兒津貼申請表（109年版本）.pdf",
      "體驗「案件快易查、市政好透明」服務同意書.odt",
      "體驗「案件快易查、市政好透明」服務同意書.pdf",
      "教育部補助地方政府發放2至4歲幼兒育兒津貼作業要點.pdf",
      "教育部補助地方政府發放二至四歲幼兒育兒津貼申請案件處理時限表.pdf",
      "教育部補助地方政府發放二至四歲幼兒育兒津貼作業流程圖P05000051.pdf",
    ],
  },
  {
    index: 7,
    name: "老人全民健康保險保險費自付額補助",
    theme: ["社會關懷", "補助獎勵"],
    themetab: ["老年人", "醫療"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "全線上／臨櫃",
    day: "14日",
    info: [
      "【申請資格】<br />1.對象<br />(1)本市未滿70歲符合中低收入老人生活津貼發給辦法第2條第1項規定資格之老人。<br />(2)其他符合下列3項規定之老人：<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbspA.年滿65歲之老人或年滿55歲之原住民",
      "且設籍並實際居住本市滿1年者。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbspB.經稅捐稽徵機關核定之最近1年綜合所得總額合計未達申報標準或綜合所得稅稅率未達20%者",
      "申報老人<br/>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp為受扶養人之納稅義務人",
      "有上開情事者亦同。<br />&nbsp&nbsp&nbsp&nbsp&nbsp&nbspC.未獲政府機關健保自付額之全額補助者。<br /><br />2.因綜合所得核定稅率達20%或未實際居住本市而不符資格者",
      "可於資格符合後主動提出申請",
      "經審核通過後",
      "<br />&nbsp&nbsp&nbsp自申請當月補助。<br />3.市民提出申請前",
      "可先電洽本局確認補助資格。",
    ],
    file: [
      "1.申請表(申請人為長者)。<br />2.因綜合所得稅核定稅率不符合補助資格者",
      "需檢附「新年度綜合所得稅核定通知書」(至納稅義務人戶籍地國稅局稽徵所申請)。《若申請人無報稅亦未被申報扶養",
      "則請改附「綜合所得稅稅籍清單」。》<br />3.因居住國內天數不符合補助資格者",
      "需檢附「入出國日期證明書」或「護照影本」(若以多重國籍護照入出國",
      "需完整檢附)。<br />4.因設籍戶政事務所不符合補助資格者",
      "需檢附「實際居住本市之書面證明」(如租賃契約書等)。",
    ],
    noonline: "請備齊應備文件向臺北市政府社會局老人福利科現場辦理。",
    download: [
      "臺北市老人健保補助申請表(109年1月修訂).docx",
      "臺北市老人健保補助申請表(109年1月修訂).odt",
      "臺北市老人健保補助申請表(109年1月修訂).pdf",
      "臺北市老人健保補助取消申請表.docx",
      "臺北市老人健保補助取消申請表.odt",
      "臺北市老人健保補助取消申請表.pdf",
    ],
  },
  {
    index: 8,
    name: "臺北市身心障礙者職務再設計服務",
    theme: ["社會關懷", "就業扶植"],
    themetab: ["身心障礙", ""],
    organ: ["勞動局"],
    organtab: ["勞動力重建運用處"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "60日",
    info: ["提供身心障礙者職能再設計服務", "其工作地點應位於本市。"],
    file: [
      "1. 申請表。<br />2. 身心障礙手冊正反面影本。<br />3. 公、勞保加保證明影本。<br />4. 合法設立之相關證明文件影本（自營業者則提供執業之合法證明文件",
      "如執業執照、稅籍登記影本等；公立機關（構）應以公函檢附申請文件提出申請）。<br />5. 自營業者另需檢附從事職業之經營或所得證明。<br />6. 自營作業者及受雇之個人另應檢附勞保資料查詢同意書。<br />7. 助聽器使用需求者另應檢附3個月內由合格聽力師出具之聽力檢測報告",
      "項目包括：1.純音聽力。2.語音聽力(SRT、SDS)。<br />8. 無障礙環境改善需求者應檢附建築物所有權狀影本、建築物所有權人同意書。<br />9. 受服務之身心障礙者職務如涉及政府部門委託或補助者",
      "應檢附計畫書、核定公文及相關文件（如契約、經費明細表等）。<br />10. 權利義務說明書。<br />11. 其他經臺北市勞動力重建運用處指定之相關文件。",
    ],
    noonline: "請備齊應備文件向臺北市勞動力重建運用處身障輔助課辦理",
    download: [
      "臺北市身心障礙者職務再設計服務申請表.doc",
      "臺北市身心障礙者職務再設計服務申請表.odt",
    ],
  },
  {
    index: 9,
    name: "特殊境遇家庭扶助之家庭暴力被害人補助",
    theme: ["社會關懷", "補助獎勵"],
    themetab: ["特殊境遇", "其他"],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "8日-30日",
    info: [
      "【各項補助申請期限】<br />&nbsp&nbsp&nbsp&nbsp1.緊急生活扶助：受害事實發生後6個月內。<br />&nbsp&nbsp&nbsp&nbsp2.法律訴訟補助：提出訴訟至判決確定後6個月內提出申請。<br />&nbsp&nbsp&nbsp&nbsp3.傷病醫療補助：就診後3個月內。<br />&nbsp&nbsp&nbsp&nbsp4.子女生活津貼：初次申請得隨時提出",
      "延長補助應於會計年度開始前2個月提出。<br />&nbsp&nbsp&nbsp&nbsp5.兒童托育津貼：托育事實發生後6個月內。",
    ],
    file: [
      "【必備】<br />(1)申請表。<br />(2)稅捐稽徵所（或稽徵處）開立之最近1年度全戶綜合所得稅各類所得資料清單及財產歸屬清單",
      "或授權社會局向國稅局財稅中心統一調查全戶財稅資料。<br />(3)身分證明文件影本。<br />(4)申請人之台北富邦商業銀行或郵局存摺封面影本。<br />(5)領據。<br /><br />【相關證明文件】<br />醫療院所收據正本<br />醫療明細表<br />診斷證明書影本<br />委任狀或訴狀影本（須具法院收狀章）<br />委任律師費用收據正本<br />判決書影本等。",
    ],
    noonline:
      "請備齊應備文件向臺北市家庭暴力暨性侵害防治中心綜合規劃及行政組現場辦理。",
    download: [
      "特殊境遇家庭扶助領據.doc",
      "特殊境遇家庭扶助領據.odt",
      "特殊境遇家庭扶助領據.pdf",
      "臺北市特殊境遇家庭扶助申請表.doc",
      "臺北市特殊境遇家庭扶助申請表.odt",
      "臺北市特殊境遇家庭扶助申請表.pdf",
    ],
  },
  {
    index: 10,
    name: "台北探索館團體導覽之旅",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["觀光傳播局"],
    organtab: ["觀光傳播局"],
    apply: "全線上／臨櫃",
    day: "2日",
    info: [
      "團體導覽時段：<br />週二～週日（9：00～17：00）<br /><br />預約導覽對象：<br />30人以上接受預約導覽（包含國小以上團體、機關",
      "個人組成團體等）。<br /><br />預約團體導覽注意事項：<br />&nbsp&nbsp&nbsp&nbsp1.請於預定參觀日期7天前提出申請",
      "預約結果視當日預約團體數量而定。<br />&nbsp&nbsp&nbsp&nbsp2.若預約當日無法前往",
      "請於原訂參觀日期5天前來電取消預約。<br />&nbsp&nbsp&nbsp&nbsp3.若遇不可抗拒重大災害（如颱風、地震等）",
      "依臺北市政府行政命令公布實施後",
      "即取消當日行程",
      "並請重新提出申請。<br />&nbsp&nbsp&nbsp&nbsp4.團體導覽包含觀賞「發現劇場」服務。",
    ],
    file: "免證件",
    noonline: "免證件",
    download: [
      "臺北探索館團體導覽之旅",
      "台北探索館團體導覽之旅.doc",
      "台北探索館團體導覽之旅.pdf",
    ],
  },
  {
    index: 11,
    name: "台北探索館自由參觀之旅",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["觀光傳播局"],
    organtab: ["觀光傳播局"],
    apply: "全線上／臨櫃",
    day: "2日",
    info: [
      "團體導覽時段：<br />週二～週日（9：00～17：00）<br /><br />預約導覽對象：<br />30人以上接受預約導覽（包含國小以上團體、機關",
      "個人組成團體等）。<br /><br />預約團體導覽注意事項：<br />&nbsp&nbsp&nbsp&nbsp1.請於預定參觀日期7天前提出申請",
      "預約結果視當日預約團體數量而定。<br />&nbsp&nbsp&nbsp&nbsp2.若預約當日無法前往",
      "請於原訂參觀日期5天前來電取消預約。<br />&nbsp&nbsp&nbsp&nbsp3.若遇不可抗拒重大災害（如颱風、地震等）",
      "依臺北市政府行政命令公布實施後",
      "即取消當日行程",
      "並請重新提出申請。<br />&nbsp&nbsp&nbsp&nbsp4.團體導覽包含觀賞「發現劇場」服務。",
    ],
    file: "免證件",
    noonline: "免證件",
    download: [
      "臺北探索館團體導覽之旅",
      "台北探索館團體導覽之旅.doc",
      "台北探索館團體導覽之旅.pdf",
    ],
  },
  {
    index: 12,
    name: "台北探索館發現劇場之旅",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["觀光傳播局"],
    organtab: ["觀光傳播局"],
    apply: "全線上／臨櫃",
    day: "2日",
    info: [
      "劇場預約對象：<br />10人以上接受預約。<br /><br />劇場預約注意事項：<br />1.請於預定參觀日期7天前提出申請",
      "預約結果視當日預約團體數量而定。<br />2.若團體於當日預約場次遲到",
      "可於下個場次視開放座位數自由入座",
      "恕無法保留座位；若預約當日無法前往",
      "請於原訂參觀日期5天前來電取消預約。<br />3.若遇不可抗拒重大災害（如颱風、地震等）",
      "依臺北市政府行政命令公布實施後",
      "即取消當日行程",
      "並請重新提出申請。",
    ],
    file: "免證件",
    noonline: "免證件",
    download: [
      "臺北探索館團體導覽之旅",
      "台北探索館團體導覽之旅.doc",
      "台北探索館團體導覽之旅.pdf",
    ],
  },
  {
    index: 13,
    name: "臺北市立兒童新樂園團體預約",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["台北捷運公司"],
    organtab: ["台北捷運公司"],
    apply: "全線上",
    day: "2日",
    info: [
      "1. 團體預約適用於一般團體30人或弱勢團體20人以上預約",
      "弱勢團體(如身心障礙團體)。<br />2. 30人(含)以上團體",
      "平常日於入園前1日17時前完成團體預約申請",
      "可享入園免門票優惠；另假日期間入園",
      "門票則按票價給予7折優惠。<br />3. 經審核通過將公布於官網團體預約行事曆",
      "預約當日抵達園區大門時",
      "服務人員將接待入園",
      "另有購卡需求者",
      "請於現場繳清費用後",
      "領取票卡進入園區。<br />4. 若申請單位為學校",
      "每班至少應有2位老師（含家長）隨行",
      "以維護學童安全及秩序。<br />5. 遊園期間應遵守園區遊客須知",
      "請參閱兒童新樂園官網。<br />6. 園區室內、外免費遊戲區(球池、滑梯、沙坑)係提供親子遊憩使用",
      "每位家(師)長限帶2名以下兒童",
      "始得進入遊玩。<br />7. 園區各項遊樂設施均使用悠遊卡付費",
      "逐項收費",
      "建議預先儲值足夠金額；如無悠遊卡者",
      "可於「悠遊卡購買需求欄」填妥購買數量及儲值金額",
      "並於入園當日現場付款",
      "以加速購票流程。",
    ],
    file: "免證件",
    noonline: "免證件",
    download: "「臺北市立兒童新樂園團體預約」作業流程圖.pdf",
  },
  {
    index: 14,
    name: "貓空纜車團體預約搭乘",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["台北捷運公司"],
    organtab: ["台北捷運公司"],
    apply: "全線上",
    day: "1日",
    info: [
      "1.須於預約進站時間前15分鐘持列印之「貓空纜車預約報到單」",
      "亦可使用行動電話、相機拍照留存預約報到單作為進站憑證",
      "或提供申請人電話、身份證字號等相關資料至纜車動物園站報到",
      "並依服務人員引導購票或自行持悠遊卡",
      "依「貓空纜車預約報到單」之預約時間搭乘",
      "進站時回收。<br />2.預約後若因故無法前往搭乘",
      "請於系統逕行取消",
      "以利其他旅客預約搭乘。<br />3.搭乘當日因遇有落雷、強風等不良天候因素導致纜車暫停營運",
      "本報到單自動失效。<br />4.相關票價及其他詳情請參閱貓空纜車網站http://www.gondola.taipei/。",
    ],
    file: "免證件",
    noonline: "免證件",
  },
  {
    index: 15,
    name: "臺北市立動物園預約導覽申請",
    theme: ["休閒相關"],
    themetab: ["休閒設施預約"],
    organ: ["教育局"],
    organtab: ["市立動物園"],
    apply: "全線上",
    day: "2日",
    info: [
      "【申辦須知】<br />&nbsp&nbsp&nbsp&nbsp1.本申辦案件免證件",
      "歡迎國小以上學童及社會團體",
      "20人以上",
      "來園10日前提出申請。<br />&nbsp&nbsp&nbsp&nbsp2.園區導覽時間約1小時。<br />&nbsp&nbsp&nbsp&nbsp3.因故未能如期來園之團體",
      "請於原定參觀日期3日前與本園聯絡改期或取消",
      "以避免社會資源浪費",
      "未遵守者恕不受理該團體再次之預約申請。<br /><br />【申辦結果】<br />&nbsp&nbsp&nbsp&nbsp1. 本園將於來園3~7天前另行通知。<br />&nbsp&nbsp&nbsp&nbsp2. 預約成功團體",
      "請依約定時間前往遊客中心報到。<br />&nbsp&nbsp&nbsp&nbsp3. 若未能如期來園",
      "請於來園3天前聯絡取消",
      "如無事先取消",
      "導致解說資源浪費",
      "本園將不再受理該團體預約申請。<br />聯絡我們",
    ],
    file: "免證件",
    noonline: "免證件",
    download: [
      "Taipei Zoo Guided Tour Application Form.odt",
      "動物園預約導覽申請表.odt",
      "動物園預約導覽申請表填寫範例.pdf",
      "臺北市立動物園預約導覽申請一次告知單.pdf",
      "臺北市立動物園預約導覽申請作業流程圖.pdf",
      "臺北市政府申請案件處理時限表-動物園預約導覽.pdf",
    ],
  },
  {
    index: 16,
    name: "臺北市立美術館受理語音導覽服務",
    theme: ["休閒相關"],
    themetab: ["導覽申請"],
    organ: ["文化局"],
    organtab: ["市立美術館"],
    apply: "全線上／臨櫃",
    day: "1日",
    info: [
      "1.本語音導覽服務免費",
      "不包含與民間單位合作之特別展覽活動。<br />2.網路申辦屬預約性質",
      "請於臺北市政府市民服務大平臺網站下載表格填妥後",
      "攜證件至服務臺洽借機具。",
    ],
    file: "身分證明文件正本(外國人憑護照)。",
    noonline: "身分證明文件正本(外國人憑護照)。",
    download: [
      "「臺北市立美術館受理語音導覽服務」作業流程圖.pdf",
      "臺北市立美術館語音導覽服務申請表.odt",
      "臺北市立美術館語音導覽服務申請表.pdf",
    ],
  },
  {
    index: 17,
    name: "參觀污水處理廠",
    theme: ["休閒相關"],
    themetab: ["政府機關參訪"],
    organ: ["工務局"],
    organtab: ["衛生下水道工程處"],
    apply: "全線上／臨櫃",
    day: "1日",
    info: "國小三年級（含）以下學生恕不受理",
    file: "免證件",
    noonline: "免證件",
    download: "參觀污水處理廠標準作業程序.pdf",
  },
  {
    index: 18,
    name: "老人自費安養中心進住",
    theme: ["醫療照護"],
    themetab: [""],
    organ: ["社會局"],
    organtab: ["社會局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 19,
    name: "嚴重特殊傳染性肺炎隔離檢疫期間防疫補償申請",
    theme: ["安全健康"],
    themetab: ["醫藥衛生"],
    organ: ["衛生局"],
    organtab: ["衛生局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 20,
    name: "在宅病故驗屍（行政相驗）服務",
    theme: ["安全健康"],
    themetab: ["其他"],
    organ: ["衛生局"],
    organtab: ["衛生局"],
    apply: "臨櫃",
    day: "2日",
  },
  {
    index: 21,
    name: "應徵役男延期徵集入營",
    theme: ["戶政相關"],
    themetab: ["兵役"],
    organ: ["兵役局"],
    organtab: ["兵役局"],
    apply: "臨櫃",
    day: "2日",
  },
  {
    index: 22,
    name: "出生登記",
    theme: ["戶政相關"],
    themetab: ["戶籍"],
    organ: ["民政局"],
    organtab: ["民政局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 23,
    name: "申請使用治喪禮廳",
    theme: ["殯葬禮儀"],
    themetab: [""],
    organ: ["民政局"],
    organtab: ["殯葬管理處"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "2日",
  },
  {
    index: 24,
    name: "申請捐贈不動產",
    theme: ["住屋相關"],
    themetab: ["購屋"],
    organ: ["財政局"],
    organtab: ["財政局"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "2日",
  },
  {
    index: 25,
    name: "申報一般土地增值稅",
    theme: ["稅務相關"],
    themetab: ["賦稅申請"],
    organ: ["財政局"],
    organtab: ["稅捐處"],
    apply: "線上 + 臨櫃／臨櫃",
    day: "2日",
  },
  {
    index: 26,
    name: "臺北市立天文科學教育館展示場定時導覽預約",
    theme: ["休閒相關"],
    themetab: ["導覽申請"],
    organ: ["教育局"],
    organtab: ["天文館"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 27,
    name: "臺北市立圖書館預約導覽申請",
    theme: ["休閒相關"],
    themetab: ["導覽申請"],
    organ: ["教育局"],
    organtab: ["圖書館"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 28,
    name: "工廠設立許可",
    theme: ["產業相關"],
    themetab: ["工廠"],
    organ: ["產業發展局"],
    organtab: ["產業發展局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 29,
    name: "動物狂犬病預防注射",
    theme: ["動物醫護"],
    themetab: ["動物醫療照顧"],
    organ: ["產業發展局"],
    organtab: ["動保處"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 30,
    name: "申請臺北市公有零售市(商)場攤(鋪)位",
    theme: ["產業相關"],
    themetab: ["農工商業者"],
    organ: ["產業發展局"],
    organtab: ["市場處"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 31,
    name: "商業名稱及所營業務登記預查",
    theme: ["產業相關"],
    themetab: ["農工商業者"],
    organ: ["產業發展局"],
    organtab: ["商業處"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 32,
    name: "台北卡金質會員驗證申請",
    theme: ["綜合申請"],
    themetab: ["一般申請"],
    organ: ["資訊局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 33,
    name: "臺北市台北二二八紀念館受理入館攝錄影、採訪申請",
    theme: ["綜合申請"],
    themetab: ["特殊拍攝"],
    organ: ["文化局"],
    organtab: ["文化局"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 34,
    name: "臺北小巨蛋廣告租用",
    theme: ["綜合申請"],
    themetab: ["廣告文宣"],
    organ: ["臺北捷運公司"],
    organtab: ["臺北捷運公司"],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 35,
    name: "臺北市觀光活動補助",
    theme: ["綜合申請", "獎勵補助"],
    themetab: ["活動申請", "活動"],
    organ: ["觀光傳播局"],
    organtab: [""],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 36,
    name: "建物門牌變更登記",
    theme: ["戶政相關"],
    themetab: ["其他"],
    organ: ["地政局"],
    organtab: [""],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 37,
    name: "臺北市政府原住民學生獎助學金",
    theme: ["社會關懷", "教育學習", "補助獎勵"],
    themetab: ["原住民", "教育學習", "其他"],
    organ: ["原民會"],
    organtab: [""],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 38,
    name: "臺北市國際會議、展覽及獎勵旅遊贊助",
    theme: ["補助獎勵"],
    themetab: ["職能"],
    organ: ["觀光傳播局"],
    organtab: [""],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    index: 39,
    name: "補助臺北市國中小學推行客家語傳承及文化推廣計畫",
    theme: ["教育學習", "補助獎勵"],
    themetab: ["文化推廣", "其他"],
    organ: ["客委會"],
    organtab: [""],
    apply: "全線上／臨櫃",
    day: "2日",
  },
  {
    "index": 40,
    "name": "結婚登記",
    "theme": ["戶政相關"],
    "themetab": ["戶籍"],
    "organ": ["民政局"],
    "organtab": ["民政局"],
    "apply": "線上 + 臨櫃／臨櫃",
    "day": "2日"
  },
  {
    "index": 41,
    "name": "離婚登記",
    "theme": ["戶政相關"],
    "themetab": ["戶籍"],
    "organ": ["民政局"],
    "organtab": ["民政局"],
    "apply": "線上 + 臨櫃／臨櫃",
    "day": "2日"
  },
  {
    "index": 42,
    "name": "收養登記",
    "theme": ["戶政相關"],
    "themetab": ["戶籍"],
    "organ": ["民政局"],
    "organtab": ["民政局"],
    "apply": "線上 + 臨櫃／臨櫃",
    "day": "2日"
  },
  {
    "index": 43,
    "name": "門牌編釘",
    "theme": ["戶政相關"],
    "themetab": ["其他"],
    "organ": ["民政局"],
    "organtab": ["民政局"],
    "apply": "全線上／臨櫃",
    "day": "2日"
  },
  {
    "index": 44,
    "name": "法人更名登記",
    "theme": ["戶政相關"],
    "themetab": ["其他"],
    "organ": ["地政局"],
    "organtab": ["地政局"],
    "apply": "線上 + 臨櫃／臨櫃",
    "day": "2日"
  },
  {
    "index": 45,
    "name": "管理者變更登記",
    "theme": ["戶政相關"],
    "themetab": ["其他"],
    "organ": ["地政局"],
    "organtab": ["地政局"],
    "apply": "線上 + 臨櫃／臨櫃",
    "day": "2日"
  }
];

export default caseData;
